@if (error) {
  <div class="error-banner">
    <div class="error-banner__content">{{ error.message }}</div>
  </div>
}

<div class="main_body">
  <div class="dashboard">
    <!-- Page Header -->
    <app-page-header [title]="i18n.title.dashboard" icon="dashboard" />

    <div class="dashboard__content">
    @if (isLoading()) {
      <!-- Skeleton Loading (uses actual card classes for identical sizing) -->
      <div class="dashboard-stat-cards">
        @for (_ of [1,2,3,4]; track $index) {
          <div class="dashboard-stat-card">
            <div class="dashboard-stat-card__icon-box skel" style="background: none;"></div>
            <div class="dashboard-stat-card__content">
              <div class="skel" style="width: 60%; height: 12px;"></div>
              <div class="skel" style="width: 45%; height: 24px;"></div>
              <div class="skel" style="width: 80%; height: 10px;"></div>
            </div>
          </div>
        }
      </div>
      <div class="dashboard-main">
        <div class="dashboard-card">
          <div class="dashboard-card__header">
            <div class="skel" style="width: 160px; height: 18px;"></div>
            <div class="skel" style="width: 24px; height: 24px;"></div>
          </div>
          <div class="dashboard-card__body">
            <div class="skel" style="width: 100%; height: 260px; border-radius: var(--radius-md);"></div>
          </div>
        </div>
        <div class="dashboard-card">
          <div class="dashboard-card__header">
            <div class="skel" style="width: 120px; height: 18px;"></div>
            <div class="skel" style="width: 24px; height: 24px;"></div>
          </div>
          <div class="dashboard-card__body">
            <div class="dashboard-notice-list">
              @for (_ of [1,2,3,4]; track $index) {
                <div class="dashboard-notice-item">
                  <div class="skel" style="width: 80px; height: 11px;"></div>
                  <div class="skel" style="width: 90%; height: 14px;"></div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    } @else {
      <!-- Row 1: 4-column Stat Cards -->
      <div class="dashboard-stat-cards">
        <!-- Total Accounts -->
        <div class="dashboard-stat-card">
          <div class="dashboard-stat-card__icon-box dashboard-stat-card__icon-box--purple">
            <mat-icon>groups</mat-icon>
          </div>
          <div class="dashboard-stat-card__content">
            <span class="dashboard-stat-card__label" i18n="@@adminSystem.home.label.totalAccounts">総アカウント数</span>
            <div class="dashboard-stat-card__value">
              <span class="dashboard-stat-card__number">{{ totalAccountNum | number }}</span>
              <span class="dashboard-stat-card__unit" i18n="@@common.unit.items">件</span>
            </div>
            @if (totalAccountNumMTMB !== 0) {
              <div class="dashboard-stat-card__trend"
                   [class.dashboard-stat-card__trend--positive]="totalAccountNumMTMB > 0"
                   [class.dashboard-stat-card__trend--negative]="totalAccountNumMTMB < 0">
                <mat-icon>{{ totalAccountNumMTMB > 0 ? 'trending_up' : 'trending_down' }}</mat-icon>
                <span>{{ totalAccountNumMTMB > 0 ? '+' : '' }}{{ totalAccountNumMTMB | number }} {{ i18n.label.monthOverMonth }}</span>
              </div>
            } @else {
              <div class="dashboard-stat-card__trend dashboard-stat-card__trend--neutral">
                <mat-icon>trending_flat</mat-icon>
                <span>±0 {{ i18n.label.monthOverMonth }}</span>
              </div>
            }
          </div>
        </div>

        <!-- New Accounts -->
        <div class="dashboard-stat-card">
          <div class="dashboard-stat-card__icon-box dashboard-stat-card__icon-box--success">
            <mat-icon>person_add</mat-icon>
          </div>
          <div class="dashboard-stat-card__content">
            <span class="dashboard-stat-card__label" i18n="@@adminSystem.home.label.newAccounts">新規アカウント数</span>
            <div class="dashboard-stat-card__value">
              <span class="dashboard-stat-card__number">{{ createdAccountNum | number }}</span>
              <span class="dashboard-stat-card__unit" i18n="@@common.unit.items">件</span>
            </div>
            @if (createdAccountNumMTMB !== 0) {
              <div class="dashboard-stat-card__trend"
                   [class.dashboard-stat-card__trend--positive]="createdAccountNumMTMB > 0"
                   [class.dashboard-stat-card__trend--negative]="createdAccountNumMTMB < 0">
                <mat-icon>{{ createdAccountNumMTMB > 0 ? 'trending_up' : 'trending_down' }}</mat-icon>
                <span>{{ createdAccountNumMTMB > 0 ? '+' : '' }}{{ createdAccountNumMTMB | number }} {{ i18n.label.monthOverMonth }}</span>
              </div>
            } @else {
              <div class="dashboard-stat-card__trend dashboard-stat-card__trend--neutral">
                <mat-icon>trending_flat</mat-icon>
                <span>±0 {{ i18n.label.monthOverMonth }}</span>
              </div>
            }
          </div>
        </div>

        <!-- Stopped Accounts -->
        <div class="dashboard-stat-card">
          <div class="dashboard-stat-card__icon-box dashboard-stat-card__icon-box--error">
            <mat-icon>person_remove</mat-icon>
          </div>
          <div class="dashboard-stat-card__content">
            <span class="dashboard-stat-card__label" i18n="@@adminSystem.home.label.removedAccounts">停止アカウント数</span>
            <div class="dashboard-stat-card__value">
              <span class="dashboard-stat-card__number">{{ removedAccountNum | number }}</span>
              <span class="dashboard-stat-card__unit" i18n="@@common.unit.items">件</span>
            </div>
            @if (removedAccountNumMTMB !== 0) {
              <div class="dashboard-stat-card__trend"
                   [class.dashboard-stat-card__trend--positive]="removedAccountNumMTMB > 0"
                   [class.dashboard-stat-card__trend--negative]="removedAccountNumMTMB < 0">
                <mat-icon>{{ removedAccountNumMTMB > 0 ? 'trending_up' : 'trending_down' }}</mat-icon>
                <span>{{ removedAccountNumMTMB > 0 ? '+' : '' }}{{ removedAccountNumMTMB | number }} {{ i18n.label.monthOverMonth }}</span>
              </div>
            } @else {
              <div class="dashboard-stat-card__trend dashboard-stat-card__trend--neutral">
                <mat-icon>trending_flat</mat-icon>
                <span>±0 {{ i18n.label.monthOverMonth }}</span>
              </div>
            }
          </div>
        </div>

        <!-- Data Overview -->
        <div class="dashboard-stat-card">
          <div class="dashboard-stat-card__icon-box dashboard-stat-card__icon-box--info">
            <mat-icon>storage</mat-icon>
          </div>
          <div class="dashboard-stat-card__content">
            <span class="dashboard-stat-card__label" i18n="@@adminSystem.home.label.totalAccounts2">全アカウント概要</span>
            <div class="dashboard-stat-card__value">
              <span class="dashboard-stat-card__number">{{ createdAccountNum + removedAccountNum + totalAccountNum | number }}</span>
              <span class="dashboard-stat-card__unit" i18n="@@common.unit.items">件</span>
            </div>
            <span class="dashboard-stat-card__sub-info">
              {{ createdAccountNum | number }} <span i18n="@@adminSystem.home.label.created">新規</span> / {{ removedAccountNum | number }} <span i18n="@@adminSystem.home.label.removed">停止</span>
            </span>
          </div>
        </div>
      </div>

      <!-- Row 2: Chart + Notices -->
      <div class="dashboard-main">
        <!-- Chart Card -->
        <div class="dashboard-card">
          <div class="dashboard-card__header">
            <h2 class="dashboard-card__title" i18n="@@adminSystem.home.title.accountPeriod">アカウント利用期間</h2>
            <mat-icon class="dashboard-card__icon">bar_chart</mat-icon>
          </div>
          <div class="dashboard-card__body">
            <div class="dashboard-chart-area">
              <apx-chart
                [series]="chartSeries"
                [chart]="chartOptions"
                [xaxis]="chartXAxis"
                [yaxis]="chartYAxis"
                [dataLabels]="chartDataLabels"
                [plotOptions]="chartPlotOptions"
                [stroke]="chartStroke"
                [fill]="chartFill"
                [grid]="chartGrid"
                [tooltip]="chartTooltip"
                [colors]="chartColors"
              ></apx-chart>
            </div>
          </div>
        </div>

        <!-- Notices Card -->
        <div class="dashboard-card">
          <div class="dashboard-card__header">
            <h2 class="dashboard-card__title" i18n="@@adminSystem.home.title.importantNotices">重要なお知らせ</h2>
            <mat-icon class="dashboard-card__icon">info</mat-icon>
          </div>
          <div class="dashboard-card__body">
            <div class="dashboard-notice-list">
              @for (notice of notices; track notice.date) {
                <div class="dashboard-notice-item">
                  <span class="dashboard-notice-item__date">{{ notice.date }}</span>
                  <p class="dashboard-notice-item__text">
                    @if (notice.link) {
                      <a [routerLink]="notice.link">{{ notice.text }}</a>
                    } @else {
                      {{ notice.text }}
                    }
                  </p>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    </div>
  </div>
</div>
